import { css } from '@linaria/core'

// Col Gaps
export const elColGap0 = css`
  grid-column-gap: 0rem;
`

export const elColGap1 = css`
  grid-column-gap: 0.25rem;
`

export const elColGap2 = css`
  grid-column-gap: 0.5rem;
`

export const elColGap3 = css`
  grid-column-gap: 0.75rem;
`

export const elColGap4 = css`
  grid-column-gap: 1rem;
`

export const elColGap6 = css`
  grid-column-gap: 1.5rem;
`

export const elColGap8 = css`
  grid-column-gap: 2rem;
`

export const elColGap10 = css`
  grid-column-gap: 2rem;
`

export const elColGap12 = css`
  grid-column-gap: 3rem;
`

// Row Gaps

export const elRowGap0 = css`
  grid-row-gap: 0rem;
`

export const elRowGap1 = css`
  grid-row-gap: 0.25rem;
`

export const elRowGap2 = css`
  grid-row-gap: 0.5rem;
`

export const elRowGap3 = css`
  grid-row-gap: 0.75rem;
`

export const elRowGap4 = css`
  grid-row-gap: 1rem;
`

export const elRowGap6 = css`
  grid-row-gap: 1.5rem;
`

export const elRowGap8 = css`
  grid-row-gap: 2rem;
`

export const elRowGap10 = css`
  grid-row-gap: 2.5rem;
`

export const elRowGap12 = css`
  grid-row-gap: 3rem;
`

// spans
export const elSpan1 = css`
  grid-column-end: span 1;
`
export const elSpan2 = css`
  grid-column-end: span 2;
`
export const elSpan3 = css`
  grid-column-end: span 3;
`
export const elSpan4 = css`
  grid-column-end: span 4;
`
export const elSpan5 = css`
  grid-column-end: span 5;
`
export const elSpan6 = css`
  grid-column-end: span 6;
`
export const elSpan7 = css`
  grid-column-end: span 7;
`
export const elSpan8 = css`
  grid-column-end: span 8;
`
export const elSpan9 = css`
  grid-column-end: span 9;
`
export const elSpan10 = css`
  grid-column-end: span 10;
`
export const elSpan11 = css`
  grid-column-end: span 11;
`
export const elSpan12 = css`
  grid-column-end: span 12;
`
export const elSpan13 = css`
  grid-column-end: span 13;
`
export const elSpan14 = css`
  grid-column-end: span 14;
`
export const elSpan15 = css`
  grid-column-end: span 15;
`
export const elSpan16 = css`
  grid-column-end: span 16;
`
export const elSpan17 = css`
  grid-column-end: span 17;
`
export const elSpan18 = css`
  grid-column-end: span 18;
`
export const elSpan19 = css`
  grid-column-end: span 19;
`
export const elSpan20 = css`
  grid-column-end: span 20;
`

// offsets
export const elOffset1 = css`
  grid-column-start: 1;
`
export const elOffset2 = css`
  grid-column-start: 2;
`
export const elOffset3 = css`
  grid-column-start: 3;
`
export const elOffset4 = css`
  grid-column-start: 4;
`
export const elOffset5 = css`
  grid-column-start: 5;
`
export const elOffset6 = css`
  grid-column-start: 6;
`
export const elOffset7 = css`
  grid-column-start: 7;
`
export const elOffset8 = css`
  grid-column-start: 8;
`
export const elOffset9 = css`
  grid-column-start: 9;
`
export const elOffset10 = css`
  grid-column-start: 10;
`
export const elOffset11 = css`
  grid-column-start: 11;
`
export const elOffset12 = css`
  grid-column-start: 12;
`
export const elOffset13 = css`
  grid-column-start: 13;
`
export const elOffset14 = css`
  grid-column-start: 14;
`
export const elOffset15 = css`
  grid-column-start: 15;
`
export const elOffset16 = css`
  grid-column-start: 16;
`
export const elOffset17 = css`
  grid-column-start: 17;
`
export const elOffset18 = css`
  grid-column-start: 18;
`
export const elOffset19 = css`
  grid-column-start: 19;
`
export const elOffset20 = css`
  grid-column-start: 20;
`
